import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./Layout/Layout";
import Home from "./Pages/Home";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import { ThemeProvider } from "./hooks/ThemeProvider";
import CategoryPosts from "./Pages/CategoryPosts";
import PostDetails from "./Pages/PostDetails";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<Home />}/>
            <Route path="/category/:category" element={<CategoryPosts />}/>
            <Route path="/post/:id" element={<PostDetails />}/>
            <Route path="/privacy-policy" element={<PrivacyPolicy />}/>
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
